import React, { Component } from 'react';
import { Footer } from '../../molecules';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The footer section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class FooterView extends Component {

	state = {
		navItems: this.genNavItems(this.props.content.landingPage.navigation.items),
	};

	/**
	 * @argument {Object[]} items
	 * @returns {Object[]}
	 */
	genNavItems (items) {
		return items.map(({ href, name }) => ({
			children: name,
			href,
		}));
	}
	render () {

		const { address, content } = this.props.content.landingPage.footer;
		const navItems = this.state.navItems;

		return (
			<Footer
				{...{
					address,
					content,
					navItems,
				}}
			/>
		);
	}

}

export default withLanguageContext(FooterView);



// WEBPACK FOOTER //
// ./src/components/views/FooterView/FooterView.js